import React from 'react';
import Disclaimer from 'components/common/general/Disclaimer';
import BrowseInfoForm from 'components/browse-info';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { toJS } from 'mobx';
import { createStyles } from '../../globalStyles';
import { createStyles as createCustomStyles } from './styles';

const BrowseInfoPage = observer((): JSX.Element => {
  const {
    domainStore: { domainHeader },
  } = useRootStore();

  const convertedDomain = toJS(domainHeader);

  const classes = createStyles();

  const customClasses = createCustomStyles({ background: convertedDomain.properties?.eStoreBackground || '' });
  return (
    <div className={customClasses.background}>
      <div className={classes.narrowPageWrapper}>
        <BrowseInfoForm />
        <Disclaimer />
      </div>
    </div>
  );
});

export default BrowseInfoPage;
